import { Vue } from './hook'
import App from './App'
import router from './router'
import store from './store'

import maiaUI from '@longfor/maia-ui'
import ElementUI from 'element-ui'
import '@longfor/maia-ui/src/assets/element-ui/index.css'   //element-ui引入该样式
import '@longfor/maia-ui/dist/styles/maia.css'   // 引入亮色主题样式
import './assets/css/reset.css'
import './assets/css/common.css'
Vue.use(ElementUI)
Vue.use(maiaUI)
import MintUI from 'mint-ui'

import 'mint-ui/lib/style.css'
Vue.use(MintUI)

import Cube from 'cube-ui'
import "@longfor/ma-icon"
Vue.use(Cube)
import maMobile from '@longfor/ma-mobile'  //引入ma-mobile依赖
import '@longfor/ma-mobile/lib/styles/ma-mobile.css' // 引入ma-mobile样式 一定要放在cube-ui引用的下面
import './assets/css/reserMobile.css'
Vue.use(maMobile)

import MaiaMobile from '@longfor/maia-ui-mobile/lib'
import '@longfor/maia-ui-mobile/lib/style.css'
Vue.use(MaiaMobile)

import vant from 'vant'
import 'vant/lib/index.css'
Vue.use(vant);

import api from "./api/index";
import request from "./api/request";
Vue.prototype.$api = api;
Vue.prototype.$request = request;


var infiniteScroll = require('vue-infinite-scroll');
Vue.use(infiniteScroll)
// 开发环境按需使用MOCK数据
// process.env.MOCK && require('@/mock')
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})
// 创建根实例
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created() {
    this.$store.state.urlParam = this.$utils.getUrlParam()
    this.$store.state.isPc = this.$utils.isPC()
  }
})



// WEBPACK FOOTER //
// ./src/main.js